import { format, parseISO } from 'date-fns';

/**
 * Formats a number as Indian Rupees: ₹1,23,456
 * @param {number} amount
 * @returns {string}
 */
export function formatCurrency(amount) {
  if (amount == null) return '—';
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(amount);
}

/**
 * Formats a date string or Date object to a human-readable date.
 * @param {string | Date} date
 * @param {string} fmt - date-fns format string, default 'dd MMM yyyy'
 */
export function formatDate(date, fmt = 'dd MMM yyyy') {
  if (!date) return '—';
  const d = typeof date === 'string' ? parseISO(date) : date;
  return format(d, fmt);
}

/**
 * Formats minutes into 'Xh Ym' string, e.g. 125 → '2h 5m'
 * @param {number} minutes
 */
export function formatDuration(minutes) {
  if (!minutes) return '0h';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m > 0 ? `${h}h ${m}m` : `${h}h`;
}

/**
 * Masks a string showing only the last 4 chars, e.g. Aadhaar, bank account.
 * @param {string} value
 */
export function maskSensitive(value) {
  if (!value) return '—';
  const str = String(value);
  return 'X'.repeat(Math.max(0, str.length - 4)) + str.slice(-4);
}

/**
 * Formats a phone number as +91 XXXXX XXXXX
 * @param {string} phone
 */
export function formatPhone(phone) {
  if (!phone) return '—';
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 10) return `+91 ${digits.slice(0, 5)} ${digits.slice(5)}`;
  return phone;
}
